const getGroups = (store) => {
  return {
    groups: store.root.groupsStore.groups || [],
    lastUsedGroupId: store.root.groupsStore.lastUsedGroupId || '',
    categories: store.category.categoryStore.categories || {},
    templates: store.root.templatesStore.templates || [],
  };
};

module.exports = {
  getGroups,
};
